export default "__VITE_ASSET__DhrgRS7N__"